import * as icons from '@coreui/icons'

export function icon(name) {
  return icons[name] || icons.cilCircle || icons.cilCheckCircle
}
